export const HEADER_STATIC_TRANSLATIONS: {
  [lang in LanguageCode]: {
    "nav.link.loading-trouble.text": string;
    "nav.link.loading-trouble.submenu.link.black-screen.text": string;
    "nav.link.loading-trouble.submenu.link.loading-screen.text": string;
    "nav.link.loading-trouble.submenu.link.infinite-reload.text": string;
    "nav.link.loading-trouble.submenu.link.failed-load-theme.text": string;

    "nav.link.promotions.text": string;
    "nav.link.promotions.submenu.link.lucky-wheel.text": string;
    "nav.link.promotions.submenu.link.welcome-winner.text": string;
    "nav.link.promotions.submenu.link.tournament-guarantee.text": string;
    "nav.link.promotions.submenu.link.spin-and-win.text": string;
    "nav.link.promotions.submenu.link.cryptobonus.text": string;
    "nav.link.promotions.submenu.link.flipout.text": string;

    "nav.link.casino": string;
    "nav.link.series": string;

    "auth.button.login": string;
    "auth.button.logout": string;
    "auth.button.create": string;
  };
} = {
  en: {
    "nav.link.promotions.text": "Features",
    "nav.link.promotions.submenu.link.lucky-wheel.text": "Lucky Wheel",
    "nav.link.promotions.submenu.link.welcome-winner.text": "Welcome Winner",
    "nav.link.promotions.submenu.link.tournament-guarantee.text":
      "Tournament guarantee",
    "nav.link.promotions.submenu.link.spin-and-win.text": "Spin&Win",
    "nav.link.promotions.submenu.link.cryptobonus.text": "First Crypto Deposit",
    "nav.link.promotions.submenu.link.flipout.text": "Flipouts",
    "nav.link.casino": "Casino",
    "nav.link.series": "Lucky Poker Launch Series",
    "auth.button.login": "Log In",
    "auth.button.logout": "Log Out",
    "auth.button.create": "Create account",
    "nav.link.loading-trouble.text": "Problem with loading",
    "nav.link.loading-trouble.submenu.link.black-screen.text": "Black screen",
    "nav.link.loading-trouble.submenu.link.loading-screen.text":
      "Loading screen doesn't disappear",
    "nav.link.loading-trouble.submenu.link.infinite-reload.text":
      "Infinite reload loop",
    "nav.link.loading-trouble.submenu.link.failed-load-theme.text":
      "failed to load theme",
  },
  zh: {
    "nav.link.promotions.text": "产品特点",
    "nav.link.promotions.submenu.link.lucky-wheel.text": "欢迎大赢家",
    "nav.link.promotions.submenu.link.welcome-winner.text": "幸运大转盘",
    "nav.link.promotions.submenu.link.tournament-guarantee.text": "比赛奖池",
    "nav.link.promotions.submenu.link.spin-and-win.text": "旋乐赛",
    "nav.link.promotions.submenu.link.cryptobonus.text": "首次加密货币存款",
    "nav.link.promotions.submenu.link.flipout.text": "每周 翻转",
    "nav.link.casino": "赌场",
    "nav.link.series": "幸运扑克启动系列",
    "auth.button.login": "登录",
    "auth.button.logout": "Log Out zh",
    "auth.button.create": "创建账户",
    "nav.link.loading-trouble.text": "加载问题",
    "nav.link.loading-trouble.submenu.link.black-screen.text": "黑屏",
    "nav.link.loading-trouble.submenu.link.loading-screen.text":
      "加载界面未消失",
    "nav.link.loading-trouble.submenu.link.infinite-reload.text": "无限重载",
    "nav.link.loading-trouble.submenu.link.failed-load-theme.text":
      "主题加载失败",
  },
};
